'use client';
import React from 'react';
import { CheckboxGroup } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

import { InputGroup } from '../InputGroup';
import { Option } from '../../entities';

export type CheckBoxGroupChange = (checkedValue: Option[]) => void;

interface MultiSelectGroupProps {
  label: string;
  options: Option[];
  selected: Option[];
  onSelectionChange: CheckBoxGroupChange;
}

export const MultiSelectGroup: React.FC<MultiSelectGroupProps> = ({ label, onSelectionChange, options, selected }) => {
  const [availableOptions, setAvailableOptions] = React.useState<string[]>([]);
  const [currentlySelected, setCurrentlySelected] = React.useState<string[]>([]);

  const handleSelection = React.useCallback(
    (selected: string[]) => {
      const r = options.filter((o: Option) => selected.includes(o.label));
      onSelectionChange(r);
    },
    [options, onSelectionChange],
  );

  React.useEffect(() => {
    setAvailableOptions(options.map(o => o.label));
  }, [options]);

  React.useEffect(() => {
    setCurrentlySelected(selected.map(s => s.label));
  }, [selected]);
  // onSelectionChange as checkBoxGroupChange

  return (
    <MultiSelectGroupWrapper className="input-group">
      <label>{label}</label>
      <CheckboxGroup onChange={handleSelection} options={availableOptions} selected={currentlySelected} />
    </MultiSelectGroupWrapper>
  );
};

const MultiSelectGroupWrapper = styled(InputGroup)`
  &.input-group {
    .ant-tabs-nav-list {
      width: 100%;

      .ant-tabs-tab {
        width: 100%;
        text-align: center;

        > div {
          width: 100%;
        }
      }
    }
  }
  .ant-checkbox-wrapper {
    margin-left: 0;
    display: flex;
    cursor: pointer;
    .ant-checkbox {
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
  }
`;
